module.exports = __webpack_public_path__ + "img/boaz.cabaa8e9.webp";